import LabServiceModel from "@/models/LabServiceModel";
import ProcessScheduleModel from "@/models/lab/ProcessScheduleModel";
import SampleModel from "@/models/lab/SampleModel";
import InstrumentInstanceModel from "@/models/lab/InstrumentInstanceModel";
import InstrumentModel from "@/models/lab/InstrumentModel";

export default class InstrumentInstanceScheduleModel extends LabServiceModel {
  modelName() {
    return 'instrument-instance-schedule';
  }
  defaults() {
    return {
      id: null,
      process_schedule_id: null,
      sample_id: null,
      instrument_id: null,
      instrument_instance_id: null,
      instrument_jig_id: null,
      instrument: null,
      schedule_index: 0,
      batch_index: 0,
      jig_index: 0,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      schedulable_task_id: null,
      schedulable_task_type: null,
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      process_schedule_id: (val) => (this.nullStringMutator(val)),
      sample_id: (val) => (this.nullStringMutator(val)),
      instrument_id: (val) => (this.nullStringMutator(val)),
      instrument_instance_id: (val) => (this.nullStringMutator(val)),
      instrument_jig_id: (val) => (this.nullStringMutator(val)),
      schedule_index: Number,
      batch_index: Number,
      jig_index: Number,
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
      schedulable_task_id: (val) => (this.nullStringMutator(val)),
      schedulable_task_type: (val) => (this.nullStringMutator(val)),
    }
  }
  validation() {
    return {}
  }
  getProcessSchedule() {
    return this.getRelatedModel(ProcessScheduleModel, 'process_schedule');
  }
  getSample() {
    return this.getRelatedModel(SampleModel, 'sample');
  }
  getInstrumentInstance() {
    return this.getRelatedModel(InstrumentInstanceModel, 'instrument_instance');
  }
  getInstrument() {
    return this.getRelatedModel(InstrumentModel, 'instrument')
  }
}
